$(document).ready(function() {
  var firstTab = $('.faq-tabs__nav li.active').data('tab');
  var firstFaq = $('#tab-' + firstTab).find('.faq-item').first();
  if (firstFaq.length) {
    firstFaq.addClass('active');
    firstFaq.find('.faq-answer').show();
  }

$('.faq-tabs__nav li').on('click', function() {
  var tabId = $(this).data('tab');

  $('.faq-tabs__nav li').removeClass('active');
  $(this).addClass('active');

  $('.faq-tab').removeClass('active');
  $('#tab-' + tabId).addClass('active');

  $('.faq-answer').slideUp();
  $('.faq-item').removeClass('active');

  var firstFaq = $('#tab-' + tabId).find('.faq-item').first();
  if (firstFaq.length) {
    firstFaq.addClass('active');
    firstFaq.find('.faq-answer').slideDown();
  }
});

$('.faq-question').on('click', function() {
  var $this = $(this);
  var parent = $this.closest('.faq-tab');
  var faqItem = $this.closest('.faq-item');
  var answer = $this.next('.faq-answer');

  if (faqItem.hasClass('active')) {
    faqItem.removeClass('active');
    answer.slideUp();
  } else {
    parent.find('.faq-item').removeClass('active');
    parent.find('.faq-answer').slideUp();

    faqItem.addClass('active');
    answer.slideDown();
  }
});
});
